import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const GlassTooltip = withStyles(theme => {
  const isDark = theme.palette.type === "dark";
  return {
    tooltip: {
      background: isDark ? "rgba(10,10,10,0.94)" : "rgba(255,255,255,0.98)",
      color: isDark ? "#F5F5F5" : "#0F172A",
      border:
        "1px solid " +
        (isDark ? "rgba(91,124,255,0.32)" : "rgba(91,124,255,0.40)"),
      backdropFilter: "blur(12px) saturate(140%)",
      WebkitBackdropFilter: "blur(12px) saturate(140%)",
      boxShadow: "0 8px 32px rgba(0,0,0,0.32)",
      fontSize: 12,
      fontWeight: 500,
      padding: "8px 12px",
      borderRadius: 8,
      whiteSpace: "pre-line",
      maxWidth: 320
    },
    arrow: {
      color: isDark ? "rgba(10,10,10,0.94)" : "rgba(255,255,255,0.98)"
    }
  };
})(Tooltip);

export default GlassTooltip;
